import type { ExcIncreaseV1AchKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const INCREASE_ACH_BASE_PATH = getResolvedPath('/clearing/vendor/increase/ach');

export const getIncreaseAchPath: EntityPathBuilder<ExcIncreaseV1AchKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return INCREASE_ACH_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.achId) {
        return undefined;
      }

      return getResolvedPath(`${INCREASE_ACH_BASE_PATH}/$achId`, context.keys);
    }
  }
};

export function getIncreaseAchDetailPath(achId: string | undefined) {
  if (!achId) {
    return undefined;
  }

  return getIncreaseAchPath({ kind: 'detail', keys: { achId } });
}
